<template>
    <v-select
            label="Appearance Constrain"
            :items="[{text: 'BLACKLIST'},{text: 'WHITELIST'}]"
            v-model="constrain"
            item-value="text"
            :rules="rules"
            append-icon="fa fa-location-arrow"
    />
</template>

<script>
    export default {
        props: ['value', 'label', 'rules'],
        name: "choose-appearance-constrain",
        data() {
            return {
                constrain: this.value
            }
        },
        mounted() {
            if (this.value === undefined)
                this.$emit('input', 'WHITELIST');
        },
        watch: {
            constrain(val) {
                this.$emit('input', val);
            },
            value(val) {
                this.constrain = val;
            }
        }
    }
</script>

<style scoped>

</style>